export default __webpack_public_path__ + "static/media/CashlessVisionIcon.c0a64dfe.svg";